/**
 * @file scripts/pages/ContactUs.jsx
 * @description
 * This is a contact page
 */
import React, {Component} from 'react';
import RequestSupportDialog from '../components/misc/RequestSupportDialog';
// import ContactSalesDialog from '../components/misc/ContactSalesDialog';

class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            warning: 'true'
        }
    }

    render(){
        return (
            <div className="contact-wrapper">
                <div className="title">Contact</div>
                <div className="actions">
                    {/* <RequestSupportDialog useButton={true} text="Contact Support"/> */}
                    {/* <ContactSalesDialog text="Contact Sales"/> */}
                </div>
                <div className="locations">
                    <div className="location">
                        <div className="header">Washington, D.C.</div>
                        <div className="address">
                            11911 Freedom Drive<br/>
                            Suite 900<br/>
                            Reston, VA  20190<br/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactUs;
